// Copyright (c) 2017 Deere & Company

import RgaSearchResult from './components';
import actionCreators from '../rga-search-results/action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    busyCounter: state.rga.search.busyCounter,
    infoReqStatus: state.rga.shared.rgaDomainValues.rgaRecallStatus.infoReqStatus,
    isEmptyRgaSearchResult: state.rga.searchResults.isEmptyRgaSearchResult,
    partReqStatus: state.rga.shared.rgaDomainValues.rgaRecallStatus.partReqStatus,
    photoReqStatus: state.rga.shared.rgaDomainValues.rgaRecallStatus.photoReqStatus,
    resultsNavigation: state.rga.searchResults.resultsNavigation,
    rgaList: state.rga.searchResults.rgaResultList,
    rgaSearchModel: state.rga.search.rgaSearchModel,
    searchFilters: state.rga.searchResults.searchFilters,
    security: state.user.security

});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {children, routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        children,
        parenpropsLocation: parentProps.location,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(RgaSearchResult);



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state-connector.js